import BuyGroupVip from './BuyGroupVip.vue'
import store from '@/store/store'
import router from '@/router/router'

const obj = {}

obj.install = function (Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(BuyGroupVip)

    //2.用new 的方式用组件构造器创建出来组件对象
    const buyGroupVip = new Construct({ router, store })

    //3.将组件对象手动挂载到某一个元素上
    buyGroupVip.$mount(document.createElement('div'))

    //4.buyGroupVip.$el对应的就是div
    document.body.appendChild(buyGroupVip.$el)

    //5.在原型中加入BuyAccountInfo
    Vue.prototype.$BuyGroupVip = buyGroupVip

}

export default obj
